import { CellClickedEvent, ColDef } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { DocumentService } from '../../services/document.service';
import { DocumentService as AdminDocumentService } from '../../services/document.service';
import { IssueService } from '../../services/issue.service';
import { ProjectsService } from '../../services/projects.service';

@Component({
  selector: 'app-admin-documents',
  templateUrl: './documents.component.html',
  styleUrl: './documents.component.scss'
})
export class DocumentsComponent {
  term: string = '';
  documents: any = [];
  documentHistory: any = [];
  friendlyDocumentHistory: any = [];
  showFriendly: boolean = false;
  projects: any = [];
  selectedProject: any = null;
  projectId: any;
  documentId: any;
  documentName: string = '';
  unassigning: boolean = false;
  sending: boolean = false;
  suppressing: boolean = false;
  documentSearchColDefs: ColDef[] = [
    { field: "originalFileName", headerName: "File Name" },
    { field: "location", headerName: "Source Location"},
    { field: "currentWorkflowStepName", headerName: "Current Workflow Step" },
    { field: "assignedUserName", headerName: "Assigned User" }
  ];  
  documentSearchGridOptions = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true
    },
    onCellClicked: this.onCellClicked.bind(this),
    paginationPageSize: 15,
    paginationPageSizeSelector: [15, 30, 45, 60],
    onGridReady: (event: any) => event.api.autoSizeAllColumns()
  };
  documentHistoryColDefs: ColDef[] = [
    { field: "version", headerName: "Version", maxWidth: 105},
    { field: "eventType", headerName: "Event Type", minWidth: 220 },
    { field: "eventData", headerName: "Event Details", minWidth: 150, flex: 1 }
  ];  
  documentHistoryGridOptions = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true
    },
    paginationPageSize: 20,
    paginationPageSizeSelector: [20, 40, 60, 80, 100],
    onGridReady: (event: any) => {
      event.api.sizeColumnsToFit();
    }
  };
  friendlyDocumentSearchColDefs: ColDef[] = [
    { field: "originalFileName", headerName: "File Name" },
    { field: "location", headerName: "Source Location"},
    { field: "currentWorkflowStepName", headerName: "Current Workflow Step" },
    { field: "assignedUserName", headerName: "Assigned User" }
  ];  
  friendlyDocumentSearchGridOptions = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true
    },
    onCellClicked: this.onCellClicked.bind(this),
    paginationPageSize: 15,
    paginationPageSizeSelector: [15, 30, 45, 60],
    onGridReady: (event: any) => event.api.autoSizeAllColumns()
  };
  friendlyDocumentHistoryColDefs: ColDef[] = [
    { field: "timestamp", headerName: "Timestamp (Local)", filter: 'agDateColumnFilter', maxWidth: 205,
      valueGetter: function(params: any) {
        if (params?.data?.timestamp) {
          return new Date(params.data.timestamp);
        } else {
          return null;
        }
      },
      cellRenderer: (data: any) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() + ' ' + (new Date(data.value)).toLocaleTimeString() : '';
      }
    },
    { field: "eventSummary", headerName: "Summary", minWidth: 150, flex: 1 }
  ];  
  friendlyDocumentHistoryGridOptions = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: true
    },
    paginationPageSize: 20,
    paginationPageSizeSelector: [20, 40, 60, 80, 100],
    onGridReady: (event: any) => {
      event.api.sizeColumnsToFit();
    }
  };
  constructor(
    private readonly projectService: ProjectsService,
    private readonly documentService: DocumentService,
    private readonly issueService: IssueService,
    private readonly adminService: AdminDocumentService
  ) {
    this.projectService.getAllProjects().subscribe(_ => {
      this.projects = _;
    });
  }
  search() {
    if (this.selectedProject == null) { return; }
    this.documentService.search(this.selectedProject.id, this.term).subscribe(_ => this.documents = _);
  }
  view(projectId: string, documentId: string, documentName: string) {
    this.projectId = projectId;
    this.documentId = documentId;
    this.documentName = documentName;
  }
  private onCellClicked(event: CellClickedEvent) {
    const selectedProjectId = event.data['projectId'];
    const selectedDocumentId = event.data['id'];
    const selectedDocumentName = event.data['originalFileName'];
    this.view(selectedProjectId, selectedDocumentId, selectedDocumentName);
    this.getHistory(selectedDocumentId);
  }
  private getHistory(documentId: string){
    this.adminService.getDocumentHistory(documentId).subscribe(_ => {
      this.documentHistory = _;
    });
    this.adminService.getFriendlyDocumentHistory(documentId).subscribe(_ => {
      this.friendlyDocumentHistory = _;
    });
  }

  unassign() {
    this.unassigning = true;
    this.adminService.unassign(this.documentId).subscribe({
      next: (_: any) => {
        this.unassigning = false;
        this.getHistory(this.documentId);
      },
      error: (_: any) => this.unassigning = false
    });
  }
  sendToError() {
    this.sending = true;
    this.adminService.sendToErrorQueue(this.documentId).subscribe({
      next: (_: any) => {
        this.sending = false;    
        this.getHistory(this.documentId);  
      },
      error: (_: any) => this.unassigning = false
    });
  }
  suppress() {
    this.suppressing = true;
    this.issueService.suppressDocument(this.projectId, this.documentId).subscribe({
      next: (_: any) => {
        this.suppressing = false;
        document.location.reload();
      },
      error: (_: any) => {
        this.suppressing = false;
        console.error(_);
      }
    });
  }
}
